/* global axios */
import ApiClient from './ApiClient';

class InteractionHistoryAPI extends ApiClient {
  constructor() {
    super('interaction_histories', { accountScoped: true });
  }

  fetchAgentInteactionHistory(queryParams = {}) {
    return axios.get(`${this.url}/`, {
      params: queryParams,
    });
  }

  getAgentInteractionHistoryFilterList(params = {}) {
    const { payload, ...restParams } = params;
    return axios.post(
      `${this.url}/filter`,
      { payload },
      {
        params: {
          ...restParams,
        },
      }
    );
  }

  fetchAgentInteactionHistoryByLLMid(llm_chatbot_id, queryParams = {}) {
    return axios.get(`${this.url}/${llm_chatbot_id}`, {
      params: queryParams,
    });
  }
}

export default new InteractionHistoryAPI();
